import React from 'react';

export const DAY_RANGE_OPTIONS = [
  { key: '7d', label: '7 días', days: 7 },
  { key: '14d', label: '14 días', days: 14 },
  { key: '30d', label: '30 días', days: 30 },
  { key: 'mes', label: 'Mes', days: 30 },
  { key: 'anio', label: 'Año', days: 365 }
];

const DaysSegmentedControl = ({ value, onChange, options = DAY_RANGE_OPTIONS }) => {

  return (
    <div className="inline-flex rounded-[14px] border border-white/10 bg-white/5 p-1">
      {options.map((option) => {
        const active = option.key === value;
        return (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange(option.key)}
            className={
              active
                ? 'px-3 py-1.5 text-xs font-semibold rounded-[12px] bg-white text-[#0B0B0F]'
                : 'px-3 py-1.5 text-xs font-medium rounded-[12px] text-white/80 hover:text-white'
            }
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default DaysSegmentedControl;
